/** Where the device's model stands. Engines that only say `available` (the native stubs) leave it out. */
export const ModelState = {
    available: "available",
    downloadable: "downloadable",
    downloading: "downloading",
    unavailable: "unavailable",
};
/** Why this device cannot run the model at all; the app then stays in lite mode and says why in Settings. */
export const Unsupported = {
    /** No `navigator.gpu`, or the browser offers no GPU adapter. */
    noWebGpu: "no_webgpu",
    /** The GPU's buffers are smaller than the model's tensors need. */
    gpuLimits: "gpu_limits",
    /** The browser reports less memory than the model needs. */
    lowMemory: "low_memory",
    /** The browser does not say how much memory there is (Safari, so every iPhone); a model too big would only crash. */
    unknownMemory: "unknown_memory",
    /** Too little room in the browser's storage for the model and a margin. */
    lowStorage: "low_storage",
    /** No Web Workers or Cache API (an old browser, or a page not served over HTTPS). */
    browser: "browser",
};
/** The event `prepare()` sends with each step of a download. */
export const PROGRESS_EVENT = "modelProgress";
//# sourceMappingURL=definitions.js.map